@if (isOpen) {
  <div class="access-denied-overlay">
    <div
      class="access-denied-container"
      role="alertdialog"
      aria-modal="true"
      aria-label="Access denied"
    >
      <div class="access-denied-body">
        <p>{{ message }}</p>
      </div>
      <div class="access-denied-footer">
        <button type="button" class="btn btn-primary" (click)="onOk()">
          OK
        </button>
      </div>
    </div>
  </div>
}
